import {
  fetchDispatchData,
  realTimeLineActivityLine,
  realTimeLineActivityNonSeed,
  fetchRealTimeWarehouseActivityData,
  fetchRealTimeWarehouseLineData,
  fetchRealTimeWarehouseCountData,
  fetchDrierStatusReport,
  fetchDrierStatusReportEven,
  fetchDrierStatusReportOdd,
  fetchWarehouseStatusData,
  fetchWarehouseStatusLineSeedData,
  fetchWarehouseStatusLineNonSeedData,
  fetchDryingTransactionTemp,
  fetchOrganizationData,
  fetchOrganization, 
} from "../../service/web_service";
import {
  fetchDataFailure,
  fetchDataRequest,
  fetchDataSuccess,
  fetchRealTimeLineActivityRequest,
  fetchRealTimeLineActivitySuccess,
  fetchRealTimeLineActivityFailure,
  realTimeLineActivityNonSeedRequest,
  realTimeLineActivityNonSeedSuccess,
  realTimeLineActivityNonSeedFailure,
  fetchRealTimeWarehouseActivityRequest,
  fetchRealTimeWarehouseActivitySuccess,
  fetchRealTimeWarehouseActivityFailure,
  fetchRealTimeWarehouseLineRequest,
  fetchRealTimeWarehouseLineSuccess,
  fetchRealTimeWarehouseLineFailure,
  fetchRealTimeWarehouseCountRequest,
  fetchRealTimeWarehouseCountSuccess,
  fetchRealTimeWarehouseCountFailure,
  fetchDrierStatusRequest,
  fetchDrierStatusSuccess,
  fetchDrierStatusFailure,
  fetchDrierStatusReportEvenRequest,
  fetchDrierStatusReportEvenSuccess,
  fetchDrierStatusReportEvenFailure,
  fetchDrierStatusReportOddRequest,
  fetchDrierStatusReportOddSuccess,
  fetchDrierStatusReportOddFailure,
  fetchWarehouseStatusFailure,
  fetchWarehouseStatusSuccess,
  fetchWarehouseStatusRequest,
  fetchWarehouseStatusLineSeedRequest,
  fetchWarehouseStatusLineSeedSuccess,
  fetchWarehouseStatusLineSeedFailure,
  fetchWarehouseStatusLineNonSeedRequest,
  fetchWarehouseStatusLineNonSeedSuccess,
  fetchWarehouseStatusLineNonSeedFailure,
  fetchDryingTransactionTempRequest,
  fetchDryingTransactionTempSuccess,
  fetchDryingTransactionTempFailure,
  fetchOrganizationRequest,
  fetchOrganizationSuccess,
  fetchOrganizationFailure,
} from "./actions";

export const fetchDataThunk =
  (organization, lineMaster) => async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      const response = await fetchDispatchData(organization, lineMaster);
      if (response?.data?.length > 0) {
        dispatch(fetchDataSuccess(response.data));
        console.log("Raw Response:", response.data);
      } else {
        dispatch(fetchDataFailure("No data found."));
      }
    } catch (error) {
      dispatch(fetchDataFailure(error.message));
    }
  };

export const fetchRealTimeLineActivityThunk =
  (organization, lineMaster, ProcesstypeId) => async (dispatch) => {
    dispatch(fetchRealTimeLineActivityRequest());
    try {
      const data = await realTimeLineActivityLine(
        organization,
        lineMaster,
        ProcesstypeId
      );
      dispatch(fetchRealTimeLineActivitySuccess(data));
    } catch (error) {
      dispatch(fetchRealTimeLineActivityFailure(error.message));
    }
  };

export const fetchRealTimeLineActivityNonSeed =
  (organization, lineMaster, ProcesstypeId) => async (dispatch) => {
    dispatch(realTimeLineActivityNonSeedRequest());
    try {
      const data = await realTimeLineActivityNonSeed(
        organization,
        lineMaster,
        ProcesstypeId
      );
      dispatch(realTimeLineActivityNonSeedSuccess(data));
    } catch (error) {
      dispatch(realTimeLineActivityNonSeedFailure(error.message));
    }
  };

export const fetchRealTimeWarehouseActivityThunk =
  (organization) => async (dispatch) => {
    dispatch(fetchRealTimeWarehouseActivityRequest());
    try {
      const data = await fetchRealTimeWarehouseActivityData(organization);
      dispatch(fetchRealTimeWarehouseActivitySuccess(data));
    } catch (error) {
      dispatch(fetchRealTimeWarehouseActivityFailure(error.message));
    }
  };
// 📌 Fetch Warehouse Line Thunk
export const fetchRealTimeWarehouseLineThunk =
  (organization, dateFrom, dateTo) => async (dispatch) => {
    console.log(organization, dateFrom, dateTo);
    dispatch(fetchRealTimeWarehouseLineRequest());
    try {
      const data = await fetchRealTimeWarehouseLineData(
        organization,
        dateFrom,
        dateTo
      );
      dispatch(fetchRealTimeWarehouseLineSuccess(data));
    } catch (error) {
      dispatch(fetchRealTimeWarehouseLineFailure(error.message));
    }
  };

// 📌 Fetch Warehouse Count Thunk
export const fetchRealTimeWarehouseCountThunk = (warehouseId) => async (dispatch) => {
  dispatch(fetchRealTimeWarehouseCountRequest());
  try {
    const data = await fetchRealTimeWarehouseCountData(warehouseId);
    dispatch(fetchRealTimeWarehouseCountSuccess(data));
  } catch (error) {
    dispatch(fetchRealTimeWarehouseCountFailure(error.message));
  }
};

export const fetchDrierStatusThunk = (organization, season, drierType) => {
  return async (dispatch) => {
    dispatch(fetchDrierStatusRequest());

    try {
      const data = await fetchDrierStatusReport(
        organization,
        season,
        drierType
      );
      dispatch(fetchDrierStatusSuccess(data));
    } catch (error) {
      dispatch(fetchDrierStatusFailure(error.message));
    }
  };
};
// Thunk for fetching Even Drier Status Report
export const fetchDrierStatusReportEvenThunk =
  (organization, season, drierType) => async (dispatch) => {
    dispatch(fetchDrierStatusReportEvenRequest());
    try {
      const data = await fetchDrierStatusReportEven(
        organization,
        season,
        drierType
      ); // Using the previously created API function
      dispatch(fetchDrierStatusReportEvenSuccess(data));
    } catch (error) {
      dispatch(fetchDrierStatusReportEvenFailure(error.message));
    }
  };

// Thunk for fetching Odd Drier Status Report
export const fetchDrierStatusReportOddThunk =
  (organization, season, drierType) => async (dispatch) => {
    dispatch(fetchDrierStatusReportOddRequest());
    try {
      const data = await fetchDrierStatusReportOdd(
        organization,
        season,
        drierType
      ); // Using the previously created API function
      dispatch(fetchDrierStatusReportOddSuccess(data));
    } catch (error) {
      dispatch(fetchDrierStatusReportOddFailure(error.message));
    }
  };

  export const fetchDryingTransactionTempThunk =
  (organization, season) => async (dispatch) => {
    dispatch(fetchDryingTransactionTempRequest());
    try {
      const data = await fetchDryingTransactionTemp(
        organization,
        season
      ); // Using the previously created API function
      dispatch(fetchDryingTransactionTempSuccess(data));
    } catch (error) {
      dispatch(fetchDryingTransactionTempFailure(error.message));
    }
  };

export const fetchWarehouseStatusThunk =
  (organization, dateFrom, dateTo) => async (dispatch) => {
    console.log(organization, dateFrom, dateTo);
    dispatch(fetchWarehouseStatusRequest());
    try {
      const response = await fetchWarehouseStatusData(
        organization,
        dateFrom,
        dateTo
      );
      dispatch(fetchWarehouseStatusSuccess(response.data));
    } catch (error) {
      dispatch(fetchWarehouseStatusFailure(error.message));
    }
  };

  // Fetch Seed Data
export const fetchWarehouseStatusLineSeedThunk = (warehouseId) => async (dispatch) => {
  dispatch(fetchWarehouseStatusLineSeedRequest());

  try {
    const response = await fetchWarehouseStatusLineSeedData(warehouseId);
    dispatch(fetchWarehouseStatusLineSeedSuccess(response.data));
  } catch (error) {
    dispatch(fetchWarehouseStatusLineSeedFailure(error.message));
  }
};

// Fetch Non-Seed Data
export const fetchWarehouseStatusLineNonSeedThunk = (warehouseId) => async (dispatch) => {
  dispatch(fetchWarehouseStatusLineNonSeedRequest());

  try {
    const response = await fetchWarehouseStatusLineNonSeedData(warehouseId);
    dispatch(fetchWarehouseStatusLineNonSeedSuccess(response.data));
  } catch (error) {
    dispatch(fetchWarehouseStatusLineNonSeedFailure(error.message));
  }
};
// fetch org

export const fetchOrganizationThunk = (organizationId) => async (dispatch) => {
  dispatch(fetchOrganizationRequest());

  try {
    const data = await fetchOrganization(organizationId); 
    console.log(data)
    dispatch(fetchOrganizationSuccess(data));
  } catch (error) {
    dispatch(fetchOrganizationFailure(error.message));
  }
};